import React from "react";
import {
  Paper,
  Typography,
  Button,
  Box,
  Chip
} from "@material-ui/core";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

export default function ConnectionOverviewCard({
  whatsapp,
  connectionHealth,
  onConnect,
  onReconnect,
  onNewQr,
  onAddFirstConnection,
  onManage
}) {
  const connected =
    whatsapp?.status === "CONNECTED";

  const awaitingQr =
    whatsapp?.status === "qrcode";

  const statusLabel = connected
    ? "Conectado"
    : awaitingQr
      ? "Aguardando leitura do QR Code"
      : "Desconectado";

  return (
    <Paper
      elevation={0}
      style={{
        marginBottom: 24,
        padding: 24,
        borderRadius: 18,
        border: "1px solid rgba(0,0,0,.08)"
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        gridGap={24}
      >
        <Box flex={1}>
          <Box display="flex" alignItems="center" mb={2}>
            <WhatsAppIcon
              style={{
                color: "#25D366",
                marginRight: 10,
                fontSize: 30
              }}
            />

            <Typography variant="h6" style={{ fontWeight: 700 }}>
              Meu WhatsApp
            </Typography>
          </Box>

          {!whatsapp ? (
            <>
              <Typography color="textSecondary">
                Nenhum WhatsApp conectado.
              </Typography>

              <Button
                style={{ marginTop: 20 }}
                variant="contained"
                color="primary"
                onClick={onAddFirstConnection}
              >
                Conectar meu primeiro WhatsApp
              </Button>
            </>
          ) : (
            <>
              <Typography>
                Conexão: <strong>{whatsapp.number || whatsapp.phone || whatsapp.name || "WhatsApp Principal"}</strong>
              </Typography>

              <Box mt={2}>
                <Chip
                  icon={connected ? <CheckCircleIcon /> : <ErrorIcon />}
                  color={connected ? "primary" : "secondary"}
                  label={statusLabel}
                />
              </Box>

              <Typography style={{ marginTop: 18 }}>
                {connected
                  ? "Sua IA está atendendo normalmente."
                  : awaitingQr
                    ? "Escaneie o QR Code para concluir a conexão."
                    : "Sua IA está pausada até a reconexão."}
              </Typography>

              <Typography style={{ marginTop: 8 }}>
                Qualidade da conexão:{" "}
                <strong>
                  {connectionHealth?.averageHealthScore || 0}%
                </strong>
              </Typography>
            </>
          )}
        </Box>

        {whatsapp && (
          <Box
            display="flex"
            flexDirection="column"
            gridGap={12}
            style={{ minWidth: 190 }}
          >
            {connected ? (
              <Button
                variant="contained"
                color="primary"
                onClick={onManage}
                style={{
                  minHeight: 42,
                  borderRadius: 10,
                  fontWeight: 800,
                  textTransform: "none"
                }}
              >
                Configurações do WhatsApp
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={onConnect}
                style={{
                  minHeight: 42,
                  borderRadius: 10,
                  fontWeight: 800,
                  textTransform: "none"
                }}
              >
                {awaitingQr
                  ? "Abrir QR Code"
                  : "Reconectar WhatsApp"}
              </Button>
            )}
          </Box>
        )}
      </Box>
    </Paper>
  );
}
